const dashboard = "/dashboard";
const management = "/management";
const buyback = "/buyback";
const goldpickup = "/goldpickup";
const goldpricing = "/goldpricing";
const generateqr = "/generateqr";
const login = "/";
const register = "/register";
const forgotpassword = "/forgotpassword";
const newpassword = "/newpassword";
const helpcenter = "/helpcenter";
const accountsettings = "/accountsettings";
const appcustomization = "/appcustomization";
const jnelabel = "/label";
const privacy = "/privacy-policy";
const balance = "/balance";
const contactus = "/contact-us";
const promo = "/promo";
const promo_form = "/promo/form";
const promo_request_approval = "/promo-request-approval";
const freezemode = "/freeze";
const twofactorauth = "/twofactorauth";
const authenticationcode = "/authenticationcode";
const authforgotpassword = "/authforgotpassword";
const twofactorauthpassword = "/twofactorauthpassword";

const RouteName = {
  dashboard,
  management,
  buyback,
  goldpickup,
  goldpricing,
  generateqr,
  login,
  register,
  forgotpassword,
  newpassword,
  helpcenter,
  accountsettings,
  appcustomization,
  jnelabel,
  privacy,
  balance,
  contactus,
  promo,
  promo_request_approval,
  promo_form,
  twofactorauth,
  authenticationcode,
  authforgotpassword,
  freezemode,
  twofactorauthpassword
};

export default RouteName;
